import React, { useEffect, useState, useRef } from 'react'
import {
  Create,
  SimpleForm,
  useTranslate,
  BooleanInput,
  FormDataConsumer,
  useRemoveFromStore,
  useNotify,
  useRedirect,
  required,
  minValue,
  useCreate,
  maxValue,
  useGetIdentity,
} from 'react-admin'
import { AutocompleteInput } from 'src/components/uiElements/fields/AutocompleteInput'
import { Grid, Box, Paper } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { Skeleton } from '@mui/material'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
import dayjs from 'dayjs'
import { CardCommon } from 'src/components/uiElements'
import { AdapterToMapperJson } from './logic/AdapterToMapperJson'
import { FormulaComponent } from './logic/FormulaComponent'
import { productServices } from 'src/services/reservation/product/product.service'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { workUnitServices } from 'src/services/reservation/workUnit/WorkUnit.service'
import { businessUnitServices } from 'src/services/reservation/businessUnit/businessUnit.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { TextInput } from 'src/components/uiElements/fields/TextInput'
import { TreeViewCheck } from 'src/components/uiElements/styledComponents/TreeViewCheck'
import { productTypeServices } from 'src/services/reservation/product-type/product_type.service'
import Modal from '@mui/material/Modal'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { GetAirFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/AirFields'
import { getCurrentWorkUnit } from 'src/components/pages/sales/business-rule/logic/commonFunctions/getCurrentWorkUnit'
import { GetInstallmentFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/InstallmentFields'
import { GetHotelFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/HotelFields'
import { GetCarFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/CarFields'
import { GetPaymentFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/PaymentFields'
import { GetOtherProductFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/OtherProductFields'
import { GetTrainSegmentFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/TrainSegmentFields'
import { NumberInput } from 'src/components/uiElements/fields/NumberInput'
import { useQuery } from 'react-query'
import { CheckboxContext } from 'src/components/pages/sales/business-rule/logic/CheckboxContext'
import { mapperHelperService } from 'src/services/auth/mapperHelper.service'
import { formatCheckedBox, updateCheckBox } from 'src/components/pages/sales/business-rule/helper/vars_helper'
import { CardParentFormula } from 'src/components/pages/sales/business-rule/logic/CardParentFormula'
import { CardTestFormula } from 'src/components/pages/sales/business-rule/logic/CardTestFormula'
import { operators } from 'src/components/pages/sales/business-rule/logic/ListOperators'
import {
  AIR,
  HOTEL,
  PAYMENT_METHOD,
  INSTALLMENT_METHOD,
  BILLING,
  CAR,
  PAYMENT_CHARGE,
  LIQUIDATION,
  OTHER,
  TRAIN_SEGMENT,
  TRAIN_PASSES,
  SETTING,
  CONTENT,
  PRODUCT_TYPE_OTHER_ID,
  PRICE,
} from 'src/components/pages/sales/business-rule/helper/const'
import { JsonInput } from 'src/components/uiElements/react-hook-fields/JsonInputReact'
import { validateNameIsValid } from 'src/components/pages/sales/business-rule/helper/validations'
import { transform } from 'src/components/pages/sales/business-rule/helper/transform'
import { GetPaymentChargeComponentFields } from 'src/components/pages/sales/business-rule/logic/fieldByProducts/PaymentFieldsComponent'
import { getRefTableDetail } from 'src/components/pages/sales/business-rule/helper/getRefTableDetail'
import { transformData } from 'src/components/pages/sales/business-rule/helper/formula_helper'
import { getAllChildrensId } from 'src/components/pages/sales/business-rule/logic/commonFunctions/getAllChildrensId'
import { useFormContext } from 'react-hook-form'
import { ContentRuleComponent } from 'src/components/pages/sales/business-rule/logic/contentRule/ContentRuleComponent'
import { SettingRuleComponent } from 'src/components/pages/sales/business-rule/logic/settingRule/SettingRuleComponent'
import { supplierServices } from 'src/services/reservation/supplier/supplier.service'
import { filterProducts } from 'src/components/pages/sales/business-rule//helper/filterProduct'
import { getBaseToBilling } from 'src/components/pages/sales/business-rule/helper/getBaseToBiling'
import { GlobalVariables } from 'src/components/pages/sales/business-rule/logic/GlobalVariables'
import { TranslateRuleType } from 'src/components/pages/sales/business-rule/helper/TranslateRuleType'
import { SelectInputSearch } from 'src/components/uiElements/fields/SelectInputSearch'

const RemoveProductIfProductChange = ({ currentWorkUnitToken }) => {
  const { setValue } = useFormContext()

  useEffect(() => {
    if (currentWorkUnitToken) {
      setValue('product_id', '')
      setValue('business_unit_token', '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkUnitToken])
}

export const BusinessRuleCreate = (props) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [create] = useCreate()
  const [loadingWorkUnits, setLoadingWorkUnits] = useState(false)
  const [businessUnits, setBusinessUnits] = useState([])
  const [loadingBusinessUnits, setLoadingBusinessUnits] = useState(false)
  const [products, setProducts] = useState([])
  const [loadingProducts, setLoadingProducts] = useState(false)
  const [airSuppliers, setAirSuppliers] = useState([])
  const [loadingAirSuppliers, setLoadingAirSuppliers] = useState(false)
  const [airAirlines, setAirAirlines] = useState([])
  const [loadingAirAirlines, setLoadingAirAirlines] = useState(false)
  const [hotelCountries, setHotelCountries] = useState([])
  const [loadingHotelCountries, setLoadingHotelCountries] = useState(false)
  const [hotelCities, setHotelCities] = useState([])
  const [loadingHotelCities, setLoadingHotelCities] = useState(false)
  const [paymentTypes, setPaymentTypes] = useState([])
  const [loadingPaymentTypes, setLoadingPaymentTypes] = useState(false)
  const [paymentMethodsBank, setPaymentMethodsBank] = useState([])
  const [loadingPaymentMethodsBank, setLoadingPaymentMethodsBank] = useState(false)
  const [paymentMethodsCard, setPaymentMethodsCard] = useState([])
  const [selectedRuleType, setSelectedRuleType] = useState()
  const [selectedProduct, setSelectedProduct] = useState()
  const [selectedCountries, setSelectedCountries] = useState([])
  const [showJsonInput, setShowJsonInput] = useState(false)
  const [json, setJson] = useState('')
  const [jsonParse, setJsonParse] = useState({})
  const [formulas, setFormulas] = useState([])
  const [jsonMapper, setJsonMapper] = useState()
  const [loadingJsonMapper, setLoadingJsonMapper] = useState(false)
  const [businessRules, setBusinessRules] = useState([])
  const [loadingBusinessRules, setLoadingBusinessRules] = useState(false)
  const [checkedBox, setCheckedBox] = useState([])
  const [variablesFormat, setVariablesFormat] = useState([])
  const [open, setOpen] = useState(false)

  const [loadingProductType, setLoadingProductType] = useState(false)
  const [productTypes, setProductTypes] = useState(false)
  const [productType, setProductType] = useState(null)
  const [hashProducts, setHashProducts] = useState([])
  const [businessUnit, setBusinessUnit] = useState(['all'])
  const [businessUnitIds, setBusinessUnitIds] = useState([])
  const [baseToBilling, setBaseToBilling] = useState([])
  const [loadingBaseBilling, setLoadingBaseBilling] = useState(false)

  const [currentWorkUnitToken, setCurrentWorkUnitToken] = useState([])
  const [currentWorkUnitName, setCurrentWorkUnitName] = useState('')
  const [currentWorkUnit, setCurrentWorkUnit] = useState([])
  const [expanded, setExpanded] = useState([])
  const [currentParentRuleId, setCurrentParentRuleId] = useState(0)
  const [parentStructureFormula, setParentStructureFormula] = useState()
  const [parentInfo, setParentInfo] = useState()
  const [parentFormulaSolve, setParentFormulaSolve] = useState({})
  const [loadingParentFormula, setLoadingParentFormula] = useState(false)
  const [optionBusinessUnit, setOptionBusinessUnit] = useState([])
  const [loadingBusinessUnit, setLoadingBusinessUnit] = useState(false)
  const [workUnitIds, setWorkUnitIds] = useState([])

  const [selectedBusinessUnits, setSelectedBusinessUnits] = useState([])

  const handleOpen = () => setOpen(true)
  const handleClose = async () => {
    const work_unit = await getCurrentWorkUnit(allWorkUnits.data, currentWorkUnitToken, setLoadingWorkUnits)
    onChangeWorkUnit(work_unit)
    setOpen(false)
  }

  const [openTestFormula, setOpenTestFormula] = useState(false)
  const [startTakePicture, setStartTakePicture] = useState(false)

  const handleOpenTestFormula = async () => {
    const isValid = await beforeSubmit()
    if (isValid) {
      setOpenTestFormula(true)
    }
  }
  const handleCloseTestFormula = () => {
    setOpenTestFormula(false)
  }
  const exportRef = useRef()
  const removeStore = useRemoveFromStore('businessRule.listVar')
  // const businessRules = useQuery('business-rule-all', businessRuleServices.getByAll)
  const ruleTypes = useQuery('rule-type-all', businessRuleServices.getRuleTypes)
  const destinationTypes = useQuery('destination-type-all', businessRuleServices.getDestinationTypes)
  const allWorkUnits = useQuery('work-unit-all', () => workUnitServices.getByOrderParent())

  useEffect(() => {
    removeStore()
    getProductType()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    ;(async () => {
      if (currentWorkUnitToken && allWorkUnits.data.length !== 0) {
        const work_unit = await getCurrentWorkUnit(
          allWorkUnits.data,
          currentWorkUnitToken,
          setLoadingWorkUnits
        )
        setCurrentWorkUnitName(showCurrentsWorkunit(work_unit))
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkUnitToken])

  useEffect(() => {
    ;(async () => {
      try {
        setLoadingBaseBilling(true)
        if (currentWorkUnit.length) {
          const base_to_billing = await getBaseToBilling(currentWorkUnit, businessUnit, businessUnitIds)
          setBaseToBilling(base_to_billing)
          return
        }
        setBaseToBilling([{ name: 'Todas', value: 'all' }])
      } catch (error) {
        setBaseToBilling([{ name: 'Todas', value: 'all' }])
      } finally {
        setLoadingBaseBilling(false)
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkUnit, businessUnitIds])

  useEffect(() => {
    if (currentWorkUnit.length && (selectedRuleType === PAYMENT_CHARGE || productType)) {
      getProducts(currentWorkUnit.map((wu) => wu?.id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkUnit, productType, selectedRuleType])

  // useEffect(() => {
  //   if (currentWorkUnit.length) {
  //     getProducts(currentWorkUnit.map((wu) => wu?.id))
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentWorkUnit])

  useEffect(() => {
    if (selectedRuleType !== PAYMENT_METHOD && selectedRuleType !== CONTENT && selectedRuleType !== SETTING) {
      getStaticJson()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWorkUnitToken, selectedProduct, selectedRuleType])

  useEffect(() => {
    ;(async () => {
      if (json) {
        try {
          setLoadingJsonMapper(true)
          if (json.length !== 0) {
            const jsonParse = await mapperHelperService(JSON.parse(json))
            checkJson()
            setJsonMapper(jsonParse)
          } else {
            setJsonMapper({})
          }
          setLoadingJsonMapper(false)
        } catch (error) {
          notify('ra.field.invalid_json', { type: 'error' })
          setLoadingJsonMapper(false)
          return
        }
      }
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [json])

  useEffect(() => {
    updateCheckBox(jsonMapper, null, checkedBox, setCheckedBox)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonMapper])

  useEffect(() => {
    let format_checkedBox = formatCheckedBox(checkedBox, operators, variablesFormat, formulas)
    setVariablesFormat(format_checkedBox)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedBox])

  useEffect(() => {
    if (currentParentRuleId > 0 && selectedRuleType !== SETTING && selectedRuleType !== CONTENT) {
      getParentRule(currentParentRuleId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentParentRuleId])

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minHeight: '250px',
    minWidth: '550px',
    height: 'auto',
    width: 'auto',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    border: 'none',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    p: 4,
  }

  const getBusinessRules = async (name, initial_load = null) => {
    if (name || initial_load) {
      try {
        const param = name ? `name__ilike=${name}` : initial_load ? initial_load : ''
        setTimeout(async () => {
          setLoadingBusinessRules(true)
          const allBusinessRules = await businessRuleServices.getByAll(param)
          setBusinessRules(allBusinessRules)
          setLoadingBusinessRules(false)
        }, 1000)
      } catch (error) {
        setBusinessRules([])
        setLoadingBusinessRules(false)
      }
    }
  }

  const getParentRule = async (parentRuleId) => {
    try {
      setLoadingParentFormula(true)
      let parentFormula = await businessRuleServices.solvedFormulaTest(null, parentRuleId)
      if (parentFormula) {
        setParentStructureFormula(parentFormula?.combine_formula)
        setParentFormulaSolve(parentFormula?.formula_applied)
        setParentInfo(parentFormula?.parent_rule_info)
      }
      setLoadingParentFormula(false)
    } catch (error) {
      setLoadingParentFormula(false)
    }
  }

  const onChangeWorkUnit = async (work_units) => {
    try {
      if (work_units && work_units.length > 0) {
        setCurrentWorkUnit(work_units)
        setProducts([])

        // Acumular todos los IDs de children de cada work unit
        const list_ids_work_units = work_units.reduce((accumulator, wu) => {
          const list_ids_work_unit = getAllChildrensId(wu)
          return [...accumulator, ...list_ids_work_unit]
        }, [])

        // getBusinessUnitByWorkUnit(list_ids_work_units)
        setWorkUnitIds(list_ids_work_units)

        if (selectedRuleType === PAYMENT_METHOD) {
          setLoadingPaymentTypes(true)
          const paymentTypesPromises = work_units.map((wu) => {
            let token = wu?.token ? wu.token : wu?.value
            return getPaymentTypes(token)
          })

          const paymentTypesResults = await Promise.all(paymentTypesPromises)
          const combinedPaymentTypes = paymentTypesResults.flat()
          const uniquePaymentTypes = combinedPaymentTypes.reduce((accumulator, current) => {
            if (!accumulator.some((item) => item.short_name === current.short_name)) {
              accumulator.push(current)
            }
            return accumulator
          }, [])
          setPaymentTypes(uniquePaymentTypes)
        }
        return
      }
      setCurrentWorkUnit([])
    } catch (error) {
      setLoadingPaymentTypes(false)
    }
  }

  const getProducts = async (workUnitIds) => {
    try {
      setLoadingProducts(true)
      let allProducts = []
      const queryParamsString = workUnitIds.map((id) => `id=${id}`).join('&')
      const products_by_work_units = await productServices.getProductByWorkUnitIds(queryParamsString)

      const getWorkUnitById = (currentWorkUnit, work_unit_id) => {
        try {
          const work_unit_found = currentWorkUnit.find((workUnit) => workUnit?.id == work_unit_id)
          return work_unit_found?.short_name
        } catch (error) {
          return null
        }
      }

      const addWorkUnitNameInProducts = async (allProducts) => {
        // add work unit names in products which not found wu names
        try {
          const allProductsWithoutNames = allProducts
            .filter((product) => !product.work_unit_name)
            .map((product) => ({ work_unit_id: product?.work_unit_id, work_unit_name: null }))
          if (!allProductsWithoutNames) return allProducts

          const workUnitIds = [...new Set(allProductsWithoutNames.map((item) => item.work_unit_id))]
          const queryParamsString = workUnitIds.map((id) => `id=${id}`).join('&')
          const work_unit_found = await workUnitServices.getByParam(
            {
              operator: 'equal',
            },
            queryParamsString
          )
          const workUnitMap = new Map()
          work_unit_found.forEach((unit) => {
            workUnitMap.set(unit.id, unit.short_name)
          })
          const updatedProducts = allProducts.map((product) => {
            if (!product.work_unit_name && workUnitMap.has(product.work_unit_id)) {
              product.work_unit_name = workUnitMap.get(product.work_unit_id)
            }
            return product
          })

          return updatedProducts
        } catch (error) {
          return allProducts
        }
      }

      if (products_by_work_units) {
        allProducts = products_by_work_units
          .filter((elem) => filterProducts(elem, productType))
          .map((elem) => ({
            token: elem.token_id,
            name: elem.product_relation.long_name,
            ref_table: getRefTableDetail(elem.product_relation.ref_table_detail),
            product_type_id: elem.product_relation.product_type_id,
            hash_product: elem.product_relation.hash_product,
            work_unit_id: elem?.work_unit_id,
            work_unit_name: getWorkUnitById(currentWorkUnit, elem?.work_unit_id),
          }))
      }

      allProducts = await addWorkUnitNameInProducts(allProducts)

      if (selectedRuleType === PAYMENT_CHARGE) {
        allProducts = [
          {
            token: 'generalToken',
            name: 'Todos',
            ref_table: 'general',
            hash_product: null,
            product_type_id: null,
          },
        ]
        setSelectedProduct(allProducts)
      }
      setProducts(allProducts)
      setLoadingProducts(false)
    } catch (error) {
      setProducts([])
      setLoadingProducts(false)
    }
  }

  const getProductType = async () => {
    try {
      setLoadingProductType(true)
      const product_type = await productTypeServices.getByParam({ limit: 999 })
      if (product_type) {
        const remove_product_type_other = product_type.filter(
          (elem) => elem.ref_table_detail !== 'other_detail'
        )
        remove_product_type_other.push({
          ref_table_detail: 'other_detail',
          short_name: 'Otros',
          long_name: 'Otros',
          id: PRODUCT_TYPE_OTHER_ID,
        })
        setProductTypes(remove_product_type_other)
      } else {
        setProductTypes([])
      }
    } catch (error) {
      setProductTypes([])
    } finally {
      setLoadingProductType(false)
    }
  }

  const onChangeBusinessUnit = async (value) => {
    const businessUnitTokens = value // Suponemos que esto es ahora un array de strings
    if (businessUnitTokens && businessUnitTokens?.length) {
      // Actualizar el historial de opciones seleccionadas
      setSelectedBusinessUnits((prevSelected) => {
        // Combinar seleccionadas actuales con las nuevas evitando duplicados
        const combined = [
          ...prevSelected,
          ...optionBusinessUnit.filter((unit) => businessUnitTokens.includes(unit.token)),
        ].reduce((acc, item) => {
          if (!acc.some((elem) => elem.token === item.token)) {
            acc.push(item)
          }
          return acc
        }, [])

        return combined
      })
      const selectedBusinessUnitIds = optionBusinessUnit
        .filter((unit) => businessUnitTokens.includes(unit.token))
        .map((unit) => unit.id)
      setBusinessUnitIds(selectedBusinessUnitIds)
      setBusinessUnit(businessUnitTokens)

      if (selectedBusinessUnitIds && selectedBusinessUnitIds?.length) {
        const queryParamsString = selectedBusinessUnitIds.map((id) => `id=${id}`).join('&')
        const products_by_business_units = await businessUnitServices.getProductsByBusinessUnits(
          queryParamsString
        )

        const productsAux = products.filter((elem) => !elem.business_product)
        const products_format = products_by_business_units
          .filter(
            (elem) =>
              !productsAux.some((product) => product.token === elem.product_by_work_unit_relation.token_id) &&
              filterProducts(elem, productType)
          )
          .map((elem) => ({
            business_product: true,
            token: elem.product_by_work_unit_relation.token_id,
            name: elem.name,
            ref_table: elem.product_by_work_unit_relation.product_relation.ref_table_detail.split('_')[0],
            product_type_id: elem?.product_by_work_unit_relation?.product_relation?.product_type_id,
            hash_product: elem?.product_by_work_unit_relation?.product_relation?.hash_product,
          }))
        setProducts([...productsAux, ...products_format])
      }
    } else {
      const productsAux = products.filter((elem) => !elem.business_product)
      setProducts(productsAux)
    }
  }

  const onChangeProduct = (e) => {
    const tokens = e.target.value // ex ["token_1", "token_2"]
    // tomamos el producto 0, ya que los demas productos, son del mismo tipo
    const product = products.find((elem) => elem.token === tokens?.[0])
    if (product?.ref_table === AIR) {
      getAirData(product)
    } else if (product?.ref_table === HOTEL) {
      getHotelData()
    }

    const productsFound = tokens
      .map((token) => products.find((product) => product.token === token))
      .filter(Boolean)
    const hashProducts = productsFound.map(({ hash_product }) => hash_product)
    setSelectedProduct(productsFound)
    // Eliminando duplicados
    const uniqueHashProducts = [...new Set(hashProducts)]
    setHashProducts(uniqueHashProducts)
  }

  const getStaticJson = async () => {
    setShowJsonInput(false)
    if (currentWorkUnitToken && selectedProduct && selectedRuleType) {
      try {
        const staticJson = await businessRuleServices.getStaticJson(
          currentWorkUnitToken,
          selectedProduct?.[0]?.token,
          selectedRuleType
        )
        setJson(JSON.stringify(staticJson.static_json, 0, 2))
      } catch (error) {
        setJson('')
      }
    }
  }

  const getAirData = (product) => {
    if (airAirlines.length === 0) {
      getAirlines()
    }
    if (airSuppliers.length === 0) {
      getAirSuppliers(product)
    }
  }

  const getAirlines = async () => {
    try {
      setLoadingAirAirlines(true)
      const allAirlines = await businessRuleServices.getAirlines()
      setAirAirlines(allAirlines)
      setLoadingAirAirlines(false)
    } catch (error) {
      setAirAirlines([])
      setLoadingAirAirlines(false)
    }
  }
  const getAirSuppliers = async (product) => {
    try {
      setLoadingAirSuppliers(true)
      const params = {
        operator: 'equal',
        product_type_id: product?.product_type_id,
        limit: 999,
        is_active: true,
      }
      const allSuppliers = await supplierServices.getByParam(params)
      setAirSuppliers(allSuppliers)
      setLoadingAirSuppliers(false)
    } catch (error) {
      setAirSuppliers([])
      setLoadingAirSuppliers(false)
    }
  }

  const getHotelData = () => {
    if (hotelCountries.length === 0) {
      getCountries()
    }
  }

  const getCountries = async () => {
    try {
      setLoadingHotelCountries(true)
      const allCountries = await businessRuleServices.getCountries()
      setHotelCountries(allCountries)
      setLoadingHotelCountries(false)
    } catch (error) {
      setHotelCountries([])
      setLoadingHotelCountries(false)
    }
  }

  const getCities = async (e) => {
    const countries = e.target.value
    const contryId = countries.find((elem) => !selectedCountries.includes(elem))
    if (contryId) {
      try {
        setLoadingHotelCities(true)
        const allCities = await businessRuleServices.getCitiesByCountry(contryId)
        setHotelCities((current) => [...current, ...allCities])
        setLoadingHotelCities(false)
      } catch (error) {
        setLoadingHotelCities(false)
      }
    } else {
      setHotelCities((current) => current.filter((elem) => countries.includes(elem.country_id)))
    }

    setSelectedCountries(countries)
  }

  const onChangeRuleType = (e) => {
    const value = e.target.value
    setSelectedRuleType(value)
    if (currentWorkUnitToken) {
      getPaymentTypes(currentWorkUnitToken)
    }
  }

  const getPaymentTypes = async (workUnitToken) => {
    try {
      const allPaymentTypes = await businessRuleServices.getPaymentTypesByWorkUnitToken(workUnitToken)
      return allPaymentTypes ? allPaymentTypes.map((elem) => elem.payment_type_relation) : []
    } catch (error) {
      return []
    }
  }

  const onChangePaymentType = (paymentTypesSelect, defaultPaymentMethod = null) => {
    const paymentType = paymentTypes.find((elem) => elem.id === paymentTypesSelect?.target.value)
    if (paymentType && paymentType.config?.endpoint) {
      const parameter = paymentType.config.endpoint.parameter
      const url = paymentType.config.endpoint.url

      getPaymentMethodsBank(url.replace(`{${parameter}}`, currentWorkUnit[parameter]), defaultPaymentMethod)
    } else {
      setPaymentMethodsBank([])
      setPaymentMethodsCard([])
    }
  }

  const getPaymentMethodsBank = async (url) => {
    try {
      setLoadingPaymentMethodsBank(true)
      const allPaymentMethodsBank = await businessRuleServices.getPaymentMethods(url)
      setPaymentMethodsBank(allPaymentMethodsBank)
      setLoadingPaymentMethodsBank(false)
    } catch (error) {
      setPaymentMethodsBank([])
      setPaymentMethodsCard([])
      setLoadingPaymentMethodsBank(false)
    }
  }

  const onChangePaymentMethod = (e) => {
    const value = e.target.value
    const cards = value
      .map((idMethod) => {
        const paymentMethod = paymentMethodsBank.find((elem) => elem.id === idMethod)
        if (paymentMethod?.cards) {
          return paymentMethod.cards.map((card) => ({
            ...card,
            idMethod: paymentMethod.id,
            nameMethod: paymentMethod.long_name,
            customId: `${paymentMethod.id}_${card.id}`,
          }))
        }
        return []
      })
      .flat()

    setPaymentMethodsCard(cards)
  }

  const checkFormulas = (array) => {
    if (array.length) {
      return array.every((item) => {
        if (item.isData) {
          return item.value !== ''
        } else {
          return item.children.length === 2 && checkFormulas(item.children)
        }
      })
    }

    return true
  }

  const checkJson = () => {
    try {
      if (json?.length !== 0) {
        const jsonParced = JSON.parse(json)
        setJsonParse(jsonParced)
        return {
          isParse: true,
          parse: jsonParced,
        }
      } else {
        setJsonParse({})
        return {
          isParse: true,
          parse: {},
        }
      }
    } catch (error) {
      notify('ra.field.invalid_json', { type: 'error' })
      return {
        isParse: false,
      }
    }
  }

  const beforeSubmit = async (captureImage = false) => {
    const checkJsonAux = checkJson()
    const checkFormulasAux = checkFormulas(formulas)

    if (!checkFormulasAux) {
      notify('ra.field.invalid_formulas', { type: 'error' })
      return null
    }
    // if (captureImage) {
    //   await waitForPicture()
    //   await CanvasImage(exportRef)
    // }
    return checkJsonAux.isParse && checkFormulasAux
  }

  const onSuccess = () => {
    notify('ra.notification.created_success_masculine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.business-rule') },
    })
    redirect('/business-rule')
  }

  const onError = () => {
    notify('ra.notification.created_error_masculine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.business-rule') },
    })
  }

  const setParentRule = (value) => {
    if (value) {
      const parentId = value?.id
      setCurrentParentRuleId(parentId)
    }
  }

  const onSubmit = async (formData) => {
    try {
      if (
        selectedRuleType !== PAYMENT_METHOD &&
        selectedRuleType !== CONTENT &&
        selectedRuleType !== SETTING
      ) {
        setStartTakePicture(true)
        const isSuccess = await beforeSubmit(true)
        if (!isSuccess) {
          return null
        }
      }
      const dataByTransform = {
        formulas,
        jsonParse,
        selectedProduct,
        selectedRuleType,
        paymentTypes,
        work_unit_token: currentWorkUnitToken,
        checkedBox,
        hash_products: hashProducts,
      }
      let transformBody = transform(formData, dataByTransform, transformData)
      await create(
        'business-rule',
        {
          data: transformBody,
        },
        { mutationMode: 'pessimistic', onSuccess, onError }
      )
    } catch (error) {
      onError()
      return
    }
  }

  const showCurrentsWorkunit = (currentWorkUnit) => {
    if (Array.isArray(currentWorkUnit)) {
      return currentWorkUnit.map((work_unit) => work_unit?.long_name).join(', ')
    }
  }


  const getOptionLabelBusinessUnit = (businessUnit) => {
    let string = ''
    const business_name = businessUnit?.fiscal_data_relation?.name || businessUnit?.fiscal_data_name
    const fantasy_name = businessUnit?.fantasy_name

    if (business_name) {
      string += '(RS) ' + business_name
    }
    if (fantasy_name) {
      string += (business_name ? ' - (NF) ' : '') + fantasy_name
    }

    return string
  }

  let searchTimeoutBusinessUnit
  const getBusinessUnit = async (user, length = 2) => {
    clearTimeout(searchTimeoutBusinessUnit)

    if (
      (!user?.fantasy_name || user.fantasy_name.length < length) &&
      (!user?.business_name || user.business_name.length < length)
    ) {
      setOptionBusinessUnit([])
      return
    }

    searchTimeoutBusinessUnit = setTimeout(async () => {
      try {
        setLoadingBusinessUnit(true)
        const queryParamsString = workUnitIds.map((id) => `work_unit_id=${id}`).join('&')
        const filter = {
          fantasy_name__ilike: user?.fantasy_name,
        }
          if (user?.business_name) {
            filter.fiscal_data__name__ilike = user?.business_name
          }
        const business_unit = await businessUnitServices.business_unit_filter(filter, queryParamsString)
        const filtered = business_unit.filter(
          (unit) => !selectedBusinessUnits.some((selected) => selected.token === unit.token)
        )

        setOptionBusinessUnit(filtered)
      } catch (error) {
        setOptionBusinessUnit([])
      } finally {
        setLoadingBusinessUnit(false)
      }
    }, 1000)
  }


  return (
    <Create {...props} actions={null} transform={transform}>
      <CardCommon title={translate('ra.title.create_businessRule')}>
        <SimpleForm onSubmit={onSubmit}>
          <Box width='100%'>
            <RemoveProductIfProductChange currentWorkUnitToken={currentWorkUnitToken} />
            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.name')} required md={6} lg={4}>
                <TextInput source='name' label='' validate={[required(), validateNameIsValid]} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.description')} required md={6} lg={4}>
                <TextInput source='description' label='' validate={[required()]} />
              </EditInputsWrap>
            </Grid>
            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.rule_type')} md={6} lg={4} required>
                {ruleTypes.isLoading ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    source='rule_type_id'
                    options={TranslateRuleType(ruleTypes.data || [], translate)}
                    label=''
                    optionsText={['long_name']}
                    onChange={onChangeRuleType}
                    validate={[required()]}
                  />
                )}
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.parent_businessRule')} md={6} lg={4}>
                <AutocompleteInput
                  source={'parent_rule'}
                  options={businessRules || []}
                  loading={loadingBusinessRules || false}
                  optionsText={['name']}
                  optionValue='id'
                  onSearch={getBusinessRules}
                  resetOnLoad={false}
                  onChange={(e) => setParentRule(e.target.value)}
                />
              </EditInputsWrap>
              {selectedRuleType === LIQUIDATION && (
                <EditInputsWrap label={translate('ra.field.rule_liquidation_type')} md={6} lg={4} required>
                  <SelectInput
                    source='rule_liquidation_type'
                    options={[
                      { short_name: 'RETAIL', long_name: 'Minorista' },
                      { short_name: 'WHOLESALER', long_name: 'Mayorista' },
                      { short_name: 'SUPPLIER', long_name: 'Proveedor' },
                    ]}
                    label=''
                    multiple
                    optionValue='short_name'
                    optionsText={['long_name']}
                    validate={[required()]}
                  />
                </EditInputsWrap>
              )}
            </Grid>

            <Grid container spacing={3}>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
              >
                <Box sx={style}>
                  <Typography
                    id='modal-modal-title'
                    variant='h5'
                    component='h2'
                    style={{ fontWeight: 'bold', fontSize: '1.5rem' }}
                  >
                    {translate('ra.title.select_work_unit')}
                  </Typography>
                  <Typography
                    variant='body2'
                    style={{ marginBottom: '20px', marginLeft: '10px', color: '#666', fontSize: '13px' }}
                  >
                    {translate('ra.message.instructive_work_unit_select')}
                  </Typography>
                  <TreeViewCheck
                    checked={currentWorkUnitToken}
                    setChecked={setCurrentWorkUnitToken}
                    nodes={allWorkUnits.data}
                    setExpanded={setExpanded}
                    expanded={expanded}
                    onlyOne={false}
                    restrictToLevel={false}
                  />
                </Box>
              </Modal>
              <FormDataConsumer>
                {({ formData }) => (
                  <EditInputsWrap
                    label={translate('ra.field.work_unit')}
                    required
                    md={6}
                    lg={4}
                    tooltiptext={
                      formData?.rule_type_id === null ? translate('ra.tooltiptext.rule_type_first') : null
                    }
                  >
                    {allWorkUnits.isLoading || loadingWorkUnits ? (
                      <Skeleton variant='rectangular' width={'100%'} height={50} />
                    ) : (
                      <Button
                        sx={{
                          width: '100%',
                          height: 'auto',
                          minHeight: '40px',
                        }}
                        onClick={handleOpen}
                        variant='outlined'
                        disabled={formData?.rule_type_id === null}
                      >
                        {currentWorkUnitName?.length ? currentWorkUnitName : translate('ra.action.select')}
                      </Button>
                    )}
                  </EditInputsWrap>
                )}
              </FormDataConsumer>

              <EditInputsWrap label={translate('ra.field.business_unit')} md={8} lg={8} required>
                <SelectInputSearch
                  size='small'
                  source='business_unit_token'
                  options={[
                    {
                      token: 'all',
                      fantasy_name: 'Todas',
                      fiscal_data_name: 'Todas',
                      id: 9999999,
                    },
                    ...selectedBusinessUnits,
                    ...optionBusinessUnit,
                  ]}
                  label=''
                  getOptionLabel={getOptionLabelBusinessUnit}
                  fields={['fantasy_name', 'business_name']}
                  optionsText={['fantasy_name', 'fiscal_data_name']}
                  loading={loadingBusinessUnits || loadingBusinessUnit}
                  separator=' - '
                  optionValue='token'
                  onOptionsClose={(selectedValues) => {
                    onChangeBusinessUnit(selectedValues)
                  }}
                  validate={[required()]}
                  onSearch={getBusinessUnit}
                  multiple
                />
              </EditInputsWrap>

              {selectedRuleType !== PAYMENT_CHARGE && (
                <EditInputsWrap label={translate('ra.field.product_type')} required md={6} lg={4}>
                  {loadingProductType ? (
                    <Skeleton variant='rectangular' width={'100%'} height={40} />
                  ) : (
                    <SelectInput
                      source='product_type'
                      options={productTypes || []}
                      label=''
                      optionsText={['long_name']}
                      showSearch
                      optionValue='id'
                      onChange={(e) => setProductType(e?.target?.value)}
                      validate={[required()]}
                    />
                  )}
                </EditInputsWrap>
              )}

              <EditInputsWrap label={translate('ra.field.product')} required md={6} lg={4}>
                {loadingProducts ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    source='product_id'
                    options={products || []}
                    label=''
                    optionsText={['name', 'work_unit_name']}
                    optionValue='token'
                    multiple
                    showSearch
                    onChange={onChangeProduct}
                    validate={[required()]}
                    defaultValue={selectedRuleType === PAYMENT_CHARGE ? ['generalToken'] : null}
                  />
                )}
              </EditInputsWrap>
            </Grid>

            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.start_validity_rule')}>
                <DatePickers source='rule_date_start' viewsShow={false} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.end_validity_rule')}>
                <FormDataConsumer>
                  {({ formData }) => (
                    <DatePickers
                      minDate={formData.rule_date_start ? dayjs(formData.rule_date_start) : false}
                      disabled={!formData.rule_date_start}
                      source='rule_date_end'
                      viewsShow={false}
                      required={formData.rule_date_start ? true : false}
                    />
                  )}
                </FormDataConsumer>
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.is_active')} required>
                <BooleanInput label={translate('ra.field.is_active')} source='is_active' fullWidth />
              </EditInputsWrap>
            </Grid>
            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.start_reservation_date')}>
                <DatePickers source='reservation_date_from' viewsShow={false} />
              </EditInputsWrap>
              <EditInputsWrap label={translate('ra.field.end_reservation_date')}>
                <FormDataConsumer>
                  {({ formData }) => (
                    <DatePickers
                      minDate={
                        formData?.reservation_date_from ? dayjs(formData?.reservation_date_from) : false
                      }
                      disabled={!formData?.reservation_date_from}
                      source='reservation_date_to'
                      viewsShow={false}
                      required={formData.reservation_date_from ? true : false}
                    />
                  )}
                </FormDataConsumer>
              </EditInputsWrap>
            </Grid>
            {selectedRuleType !== SETTING && selectedRuleType !== CONTENT && (
              <Grid container spacing={3}>
                <EditInputsWrap label={translate('ra.field.start_service_date')}>
                  <DatePickers source='date_in_from' viewsShow={false} />
                </EditInputsWrap>
                <EditInputsWrap label={translate('ra.field.end_service_date')}>
                  <FormDataConsumer>
                    {({ formData }) => (
                      <DatePickers
                        minDate={formData?.date_in_from ? dayjs(formData?.date_in_from) : false}
                        disabled={!formData?.date_in_from}
                        source='date_in_to'
                        required={formData.date_in_from ? true : false}
                        viewsShow={false}
                      />
                    )}
                  </FormDataConsumer>
                </EditInputsWrap>
              </Grid>
            )}
            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.priority')} required>
                <NumberInput
                  source='priority'
                  label=''
                  fullWidth
                  validate={[
                    required(),
                    minValue(1),
                    maxValue(100000),
                    // (priority) => validatePriority(priority, currentWorkUnitToken, selectedProduct),
                  ]}
                  noDecimal
                  helperText={translate('ra.message.number_input')}
                />
              </EditInputsWrap>
            </Grid>

            <Grid container spacing={3}>
              <EditInputsWrap label={translate('ra.field.destination_type')} required>
                {destinationTypes.isLoading ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <SelectInput
                    source='destination_type_id'
                    options={destinationTypes.data}
                    label=''
                    optionsText={['name']}
                    defaultValue={3}
                    validate={[required()]}
                  />
                )}
              </EditInputsWrap>
              {/* {selectedRuleType === BILLING && (
                <EditInputsWrap label={translate('ra.field.config')}>
                  <TextInputRA
                    source='json_billing'
                    label=''
                    fullWidth
                    validate={isJsonValidate}
                    multiline
                    format={(v) => {
                      return JSON.stringify(v ? v : undefined)
                    }}
                    parse={(v) => {
                      try {
                        if (v.length >= 2) {
                          return JSON.parse(v)
                        }
                      } catch (e) {
                        notify('ra.field.invalid_json', { type: 'error' })
                        return undefined
                      }
                    }}
                  />
                </EditInputsWrap>
              )} */}
            </Grid>

            {(selectedRuleType === BILLING || selectedRuleType === LIQUIDATION) && (
              <Grid container spacing={1} style={{ marginTop: '25px' }}>
                <EditInputsWrap label={translate('ra.field.is_berlin')}>
                  <BooleanInput source='is_berlin' label={null} />
                </EditInputsWrap>

                <EditInputsWrap label={translate('ra.field.base_to_billing')} required md={6} lg={4}>
                  {loadingBaseBilling ? (
                    <Skeleton variant='rectangular' width={'100%'} height={40} />
                  ) : (
                    <SelectInput
                      source='base_to_billing'
                      options={baseToBilling || []}
                      label=''
                      optionsText={['name']}
                      optionValue='value'
                      multiple
                      showSearch
                      validate={[required()]}
                      defaultValue={['all']}
                    />
                  )}
                </EditInputsWrap>
              </Grid>
            )}

            {selectedProduct?.[0]?.ref_table === AIR && (
              <GetAirFields
                loadingAirAirlines={loadingAirAirlines}
                airAirlines={airAirlines}
                loadingAirSuppliers={loadingAirSuppliers}
                airSuppliers={airSuppliers}
                selectedRuleType={selectedRuleType}
              />
            )}
            {selectedProduct?.[0]?.ref_table === HOTEL && (
              <GetHotelFields
                loadingHotelCountries={loadingHotelCountries}
                hotelCountries={hotelCountries}
                getCities={getCities}
                loadingHotelCities={loadingHotelCities}
                hotelCities={hotelCities}
              />
            )}

            {selectedProduct?.[0]?.ref_table === CAR && <GetCarFields />}

            {(selectedProduct?.[0]?.ref_table === TRAIN_SEGMENT ||
              selectedProduct?.[0]?.ref_table === TRAIN_PASSES) &&
              selectedRuleType !== SETTING &&
              selectedRuleType !== CONTENT && <GetTrainSegmentFields selectedRuleType={selectedRuleType} />}

            {selectedProduct?.[0]?.ref_table === OTHER &&
              (selectedRuleType === LIQUIDATION ||
                selectedRuleType === BILLING ||
                selectedRuleType === PRICE) && <GetOtherProductFields product={selectedProduct?.[0]} />}

            {selectedRuleType === PAYMENT_METHOD && (
              <GetPaymentFields
                currentWorkUnit={currentWorkUnit}
                paymentTypes={paymentTypes}
                onChangePaymentType={onChangePaymentType}
                paymentMethodsBank={paymentMethodsBank}
                loadingPaymentMethodsBank={loadingPaymentMethodsBank}
                loadingPaymentTypes={loadingPaymentTypes}
                onChangePaymentMethod={onChangePaymentMethod}
                paymentMethodsCard={paymentMethodsCard}
              />
            )}
            {selectedRuleType === INSTALLMENT_METHOD && <GetInstallmentFields />}

            {selectedRuleType === PAYMENT_CHARGE && currentWorkUnit?.length && (
              <GetPaymentChargeComponentFields workUnitToken={currentWorkUnit} />
            )}

            {selectedRuleType === CONTENT && <ContentRuleComponent />}
            {selectedRuleType === SETTING && <SettingRuleComponent />}
          </Box>

          {selectedRuleType !== PAYMENT_METHOD &&
            selectedRuleType !== CONTENT &&
            selectedRuleType !== SETTING && (
              <CheckboxContext.Provider
                value={{ checkedBox, setCheckedBox, variablesFormat, setVariablesFormat }}
              >
                <Box style={{ width: '100%', height: 'auto', position: 'relative' }}>
                  <Paper style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
                    <Box style={{ postion: 'relative', width: '100%', height: 'auto' }}>
                      <EditInputsWrap label={translate('ra.field.json')}>
                        <AdapterToMapperJson
                          json={json}
                          showJsonInput={showJsonInput}
                          jsonMapper={jsonMapper}
                          loading={loadingJsonMapper}
                          getStaticJson={getStaticJson}
                          setJson={setJson}
                          setShowJsonInput={setShowJsonInput}
                        />
                      </EditInputsWrap>
                    </Box>

                    {currentParentRuleId > 0 && (
                      <CardParentFormula
                        loading={loadingParentFormula}
                        initialFormulas={parentStructureFormula}
                        formula_applied={parentFormulaSolve?.formula_applied}
                        parentInfo={parentInfo}
                      />
                    )}

                    {openTestFormula && (
                      <CardTestFormula
                        child_formula={formulas}
                        child_checkedBox={checkedBox}
                        currentParentRuleId={currentParentRuleId}
                        openTestFormula={openTestFormula}
                        handleCloseTestFormula={handleCloseTestFormula}
                        jsonRequestExample={selectedRuleType === PRICE && jsonParse}
                      />
                    )}

                    <Box>
                      <Box style={{ display: 'flex', flex: 1, marginLeft: '20px' }}>
                        <Grid container spacing={3}>
                          <GlobalVariables />
                        </Grid>
                      </Box>
                      <Box
                        style={{
                          display: 'flex',
                          width: '100%',
                          margin: '10px 0px',
                          justifyContent: 'right',
                        }}
                      >
                        <Button
                          sx={{
                            width: 'auto',
                            height: '40px',
                            margin: '0px 20px 0px 10px',
                          }}
                          onClick={() => {
                            handleOpenTestFormula()
                          }}
                          variant='outlined'
                          disabled={formulas?.structure?.length || formulas?.length === 0 ? true : false}
                        >
                          {translate('ra.action.test_rule')}
                        </Button>
                      </Box>
                    </Box>

                    <Box style={{ display: 'flex', width: '100%', margin: '10px 0px' }}>
                      <FormulaComponent
                        formulas={formulas}
                        setFormulas={setFormulas}
                        // initialFormulas={formulaStructure} para clonar
                      />
                    </Box>
                  </Paper>

                  {/* <Box
                    ref={exportRef}
                    style={{
                      position: 'absolute',
                      right: -32110,
                      width: '95%',
                      height: 'auto',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {startTakePicture && (
                      <CardTestFormula
                      child_formula={formulas}
                      child_checkedBox={checkedBox}
                      currentParentRuleId={currentParentRuleId}
                      openTestFormula={openTestFormula}
                      handleCloseTestFormula={handleCloseTestFormula}
                      jsonRequestExample={selectedRuleType === PRICE && jsonParse}
                      />
                    )}
                  </Box> */}
                </Box>

                {selectedRuleType === BILLING && (
                  <Grid container spacing={1} style={{ marginTop: '25px' }}>
                    <EditInputsWrap label={translate('ra.field.config')}>
                      <JsonInput source='json_billing' />
                    </EditInputsWrap>
                  </Grid>
                )}
              </CheckboxContext.Provider>
            )}
        </SimpleForm>
      </CardCommon>
    </Create>
  )
}
